// Identity state machine — xstate v5

import { setup, assign } from 'xstate';

export type IdentityContext = Readonly<{
  publicKey?: string;
  privateKey?: string;
  fingerprint?: string;
  errorMessage?: string;
}>;

type IdentityEvents =
  | { type: 'GENERATE' }
  | { type: 'IMPORT'; privateKey: string }
  | { type: 'RESTORE'; publicKey: string; privateKey: string; fingerprint: string }
  | { type: 'EXPORT' }
  | { type: 'RETRY' }
  | { type: 'GENERATE_DONE'; publicKey: string; privateKey: string; fingerprint: string }
  | { type: 'IMPORT_DONE'; publicKey: string; privateKey: string; fingerprint: string }
  | { type: 'IMPORT_ERROR'; message: string }
  | { type: 'EXPORT_DONE' };

export const identityMachine = setup({
  types: {
    context: {} as IdentityContext,
    events: {} as IdentityEvents,
  },
}).createMachine({
  id: 'identity',
  initial: 'uninitialized',
  context: {
    publicKey: undefined,
    privateKey: undefined,
    fingerprint: undefined,
    errorMessage: undefined,
  },
  states: {
    uninitialized: {
      on: {
        GENERATE: { target: 'generating' },
        IMPORT: { target: 'importing' },
        RESTORE: {
          target: 'ready',
          actions: assign({
            publicKey: ({ event }) => event.publicKey,
            privateKey: ({ event }) => event.privateKey,
            fingerprint: ({ event }) => event.fingerprint,
            errorMessage: () => undefined,
          }),
        },
      },
    },
    generating: {
      on: {
        GENERATE_DONE: {
          target: 'ready',
          actions: assign({
            publicKey: ({ event }) => event.publicKey,
            privateKey: ({ event }) => event.privateKey,
            fingerprint: ({ event }) => event.fingerprint,
            errorMessage: () => undefined,
          }),
        },
      },
    },
    ready: {
      on: {
        EXPORT: { target: 'exporting' },
      },
    },
    importing: {
      on: {
        IMPORT_DONE: {
          target: 'ready',
          actions: assign({
            publicKey: ({ event }) => event.publicKey,
            privateKey: ({ event }) => event.privateKey,
            fingerprint: ({ event }) => event.fingerprint,
            errorMessage: () => undefined,
          }),
        },
        IMPORT_ERROR: {
          target: 'error',
          actions: assign({
            errorMessage: ({ event }) => event.message,
          }),
        },
      },
    },
    exporting: {
      on: {
        EXPORT_DONE: { target: 'ready' },
      },
    },
    error: {
      on: {
        RETRY: { target: 'generating' },
      },
    },
  },
});
